/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import {getSafeLocalStorageItem} from '@/utils/localStorageHelper';
import root from '../_helpers/roots';

let loginurl = root.loginUrl.link;
let loginotpurl = root.loginOtpUrl.link;
let acuserurl = root.acUserUrl.link;
let userLoginDetailsURL = root.userLoginDetailsUrl.link;
let newUserRegisteredURL = root.newUserRegisteredUrl.link;
let newSignupedUserListURL = root.newSignupedUserListUrl.link;
let professionCategoriesListURL = root.professionCategoriesListUrl.link;
let newUserVerificationUrl = root.newUserVerificationUrl.link;
let unsbcrbUserApiUrl = root.unsbcrbUserApiUrl.link;
let userFeedbackSubmittedApiURL = root.userFeedbackSubmittedApiUrl.link;
let uploadLicenseFileOfDoctorApiUrl = root.uploadLicenseFileOfDoctorApiUrl.link;
let userLogoutApiUrl = root.userLogoutApiUrl.link;
let selfUserActivityTrackerApiUrl = root.selfUserActivityTrackerApiUrl.link;
let webSignupMobileUpdateApiUrl = root.webSignupMobileUpdateApiUrl.link;
let requestForDemoApiUrl = root.requestForDemoApiUrl.link;
let loginUserApiUrl = root.loginUserApiUrl.link;
let forgotPwForOtpApiUrl = root.forgotPwForOtpApiUrl.link;
let optVerifyForForgotPwApiUrl = root.optVerifyForForgotPwApiUrl.link;
let createNewPwOfAuthApiUrl = root.createNewPwOfAuthApiUrl.link;
let timeSlotsForDemoApiUrl = root.timeSlotsForDemoApiUrl.link;
let timeSlotsConvertedApiUrl = root.timeSlotsConvertedApiUrl.link;
let otpGenerateForDemoReqApiUrl = root.otpGenerateForDemoReqApiUrl.link;
let demoFeedbackSubmitApiUrl = root.demoFeedbackSubmitApiUrl.link;

export default {
  state: {
    token: (getSafeLocalStorageItem())
      ? localStorage.getItem('token')
      : '',
    status: '',
    acUserDetailsState:'',
    signUpedUserListState:''
  },
  mutations: {
    authSuccess(state, token) {
      state.token = token;
      state.status = 'success';
    },
    authError(state) {
      state.token = '';
      state.status = 'error';
    },
    authLogout(state) {
      state.token = '';
      state.status = '';
    },
    AcUserDetailsM(state, value) {
      Vue.set(state, 'acUserDetailsState', value);
    },
    signUpedUserListMut(state, value) {
      Vue.set(state, 'signUpedUserListState', value);
    },
  },
  actions: {
    demoFeedbackRequestCheckAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(demoFeedbackSubmitApiUrl + payload.token + '/').then(
            (response) => {
              resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    demoFeedbackSubmitAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(demoFeedbackSubmitApiUrl + payload.token + '/', payload.data).then(
            (response) => {
              resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    alreadyBookedSlotListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(requestForDemoApiUrl).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getTimeSlotsWithZoneAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(timeSlotsConvertedApiUrl).then(
            (response) => {
              resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getTimeSlotsforDemoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(timeSlotsForDemoApiUrl).then(
            (response) => {
              resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    createNewPwOfAuthApiAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(createNewPwOfAuthApiUrl, payload).then(
            (response) => {
              resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    optVerifyForForgotPwApiAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(optVerifyForForgotPwApiUrl, payload).then(
            (response) => {
              resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    forgotPwForOtpGenerateAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(forgotPwForOtpApiUrl, payload).then(
            (response) => {
              resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    loginUserWithPwAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginUserApiUrl, payload)
          .then((response) => {
            context.commit('authSuccess', response.data.data.token);
            localStorage.setItem('LoginedUserID', response.data.data.user.id);
            localStorage.setItem('token', response.data.data.token);
            axios.defaults.headers.common['Authorization'] = "Token " + response.data.data.token;
            axios.defaults.headers.post['Content-Type'] = 'application/json';
            resolve(response);
          })
          .catch((error) => {
            localStorage.removeItem('token');
            context.commit('authError');
            reject(error);
          })
      })
    },
    otpGenerateForDemoReqAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(otpGenerateForDemoReqApiUrl, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    requestForDemoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(requestForDemoApiUrl, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    webUserVerificationAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(webSignupMobileUpdateApiUrl, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    selfUserActivityTrackerMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(selfUserActivityTrackerApiUrl, payload).then(
            (response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            })
      })
    },
    uploadLicenseFileOfDoctorMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(uploadLicenseFileOfDoctorApiUrl, payload).then((response) => {
              resolve(response);
            }).catch((error) => {reject(error);})
      })
    },
    unsbcrbUserFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(unsbcrbUserApiUrl + payload.id + '/').then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    userFeedbackSubmittedFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(userFeedbackSubmittedApiURL, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    newUserVerificationFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(newUserVerificationUrl, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    checkUserLoginDetails(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(userLoginDetailsURL, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    checkLoginType(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginurl, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    loginWithOtp(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginotpurl, payload)
          .then((response) => {
            context.commit('authSuccess', response.data.data.token);
            localStorage.setItem('LoginedUserID', response.data.data.user.id);
            localStorage.setItem('token', response.data.data.token);
            axios.defaults.headers.common['Authorization'] = "Token " + response.data.data.token;
            axios.defaults.headers.post['Content-Type'] = 'application/json';
            resolve(response);
          })
          .catch((error) => {
            localStorage.removeItem('token');
            context.commit('authError');
            reject(error);
          })
      })
    },
    logoutManual(context) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('token');
        localStorage.removeItem('LoginedUserID');
        localStorage.removeItem('userAgreementState');
        delete axios.defaults.headers.common['Authorization'];
        window.location.href = '/';
        // context.commit('authLogout');
        resolve();
      })
    },
    logoutAction(context) {
      return new Promise((resolve, reject) => {
        let payload = {
          type: "web"
        }
        axios.post(userLogoutApiUrl, payload)
          .then((response) => {
            window.location.href = '/';
            localStorage.removeItem('token');
            localStorage.removeItem('LoginedUserID');
            localStorage.removeItem('userAgreementState');
            delete axios.defaults.headers.common['Authorization'];
            // context.commit('authLogout');
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getAuthHeader() {
      return {
        'Authorization': 'Token ' + localStorage.getItem('token')
      }
    },
    // Get Data Well Task Details
    getAcUserDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(acuserurl, payload).then(res => {
              context.commit('AcUserDetailsM', res.data);
              resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    NewUserSignUpFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(newUserRegisteredURL, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getListOfSignupedUserFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(newSignupedUserListURL).then(
            (response) => {
              context.commit('signUpedUserListMut', response.data);
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getProfessionCategoriesListFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(professionCategoriesListURL).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
    isAuthenticated: state => !!state.token && !!localStorage.getItem('LoginedUserID'),
    authStatus: state => state.status,
    acUserDetailsStateGetters: state => state.acUserDetailsState,
    signUpedUsersListGetters: state => state.signUpedUserListState
  }
}
